<style>
button {
  padding: 0;
}

.screen {
  background-image: linear-gradient(-90deg, #ff0066 0%, #f15a24 100%);
}

.container {
  /* border: solid 1px #fff; */
  height: 100vh;
  /* max-height: 450px; */
  justify-content: center;
}

.header {
  color: #fff;
  text-transform: uppercase;
  font-weight: bold;
  display: flex;
  align-items: center;
  /* border: solid 1px blue; */
  flex-direction: column;
  user-select: none;
}

.header__copy {
  text-align: center;
  line-height: 125%;
}

.header__members {
  /* border: solid 1px blue; */
  /* flex-direction: column; */
  pointer-events: none;
  white-space: nowrap;
  padding: 0 30px;
  width: 90%;
}

.header__members--join {
  /* border: solid 1px green; */
  display: inline-block;
  width: 50%;
  vertical-align: middle;
}

.header__members--avatars {
  display: inline-block;
  width: 50%;
  vertical-align: middle;
}

.header__pricing img {
  width: 90%;
  margin: 0 0 10px;
}

.user {
  width: 90%;
  /* margin: 10px; */
  /* border: solid 1px blue; */
}

.user__input {
  position: relative;
  /* border: solid 1px green; */
}

.user__input input {
  width: 100%;
  text-align: left;
  text-indent: 20px;
  margin: 0 0 10px;
  padding: 10px 0;
  border: 1px solid #cccccc;
  border-radius: 6.58px;
  font-family: Avenir;
  font-size: 19.74px;
  color: #ff0066;
  letter-spacing: 0;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #cccccc;
  border-radius: 6.58px;
  font-weight: 500;
  text-transform: initial;
}

.input__msg {
  color: #fff;
  position: absolute;
  top: 3px;
  text-transform: uppercase;
  right: 3px;
  font-size: 10px;
  padding: 3px;
  border-radius: 2px;
  opacity: 0.9;
}

.user__input--stripe {
  /* width: 90%; */
  margin: 10px auto 15px;
}

.input__msg--warn {
  background: #f15725;
  z-index: 1;
}

.input__msg--ok {
  background: #5dc985;
  padding: 2px;
}

.input__msg--info {
  background: #5bbdf1;
}

.input__msg--throb {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(204, 0, 44, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}

::placeholder {
  color: #b3b3b3;
}

.footer__legal {
  margin-top: 15px;
  font-size: 13px;
  line-height: 20px;
  color: #fba3a8;
  text-transform: none;
}
.footer__legal--link {
  color: inherit;
}
.footer__legal--currency {
  margin-top: 10px;
  display: block;
}

.plans-container img {
  margin: 10px 0;
}

.payment {
  /* border: solid 1px green; */
  width: 90%;
  /* margin: 10px; */
}

.button {
  /* width: 90%; */
  border-radius: 6.58px;
}

.button--stripe {
  background: linear-gradient(to right, #d723fe 0%, #9b32ef 100%) !important;
}

.button--applepay {
  background: linear-gradient(to right, #111 0%, #000 100%) !important;
}

.button img {
  width: 80%;
}

.stripe-card {
  padding: 15px 20px;
  background: #fff;
  border-radius: 6.58px;
  text-transform: lowercase;
  border: 1px solid #cccccc;
}

.stripe-card.stripeTokenCreated {
  border: solid 2px #6fce91;
}

#apple-pay-container {
  display: none;
}

.hurricane {
  position: fixed;
  top: 0px;
  left: 0;
  background: #ade6c0;
  display: block;
  width: 100%;
  font-size: 12px;
  color: #333;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}

.hurricane__inner {
  padding: 10px;
}

.error_password {
  background: #ffd654;
  border-radius: 7px;
  padding: 20px;
  margin: 10px 0 15px;
  font-size: 10px;
  text-transform: initial;
  box-shadow: 0 1px 5px #00000057;
  color: #313131;
  text-align: left;
  border: solid 1px #ab891e61;
  line-height: 14px;
  display: flex;
  align-items: center;
}

.error_password i {
  opacity: 0.6;
  margin: 0 20px 0 0;
  font-size: 33px;
}

.error_password strong {
  font-size: 12px;

  display: block;
}

.error_password a {
  color: #444;
}
</style>

<template>
  <div>
    <div class="hurricane" v-if="emailExistsError && validEmail()">
      <div class="hurricane__inner">
        <span style="font-weight:bold">👋 Hey {{this.tmp.email}}!</span>
        <br />
        <div
          style="font-size:10px; margin: 5px 0 0"
        >We recognize your email; you'll be logged into your account</div>
      </div>
    </div>

    <div class="container">
      <div class="header">
        <h1 class="header__copy">
          <img src="../assets/img/simple/header__copy.png" />
        </h1>

        <div class="header__members">
          <img class="header__members--join" src="../assets/img/simple/header__copy--join.png" />
          <img class="header__members--avatars" src="../assets/img/simple/header__avatars.png" />
        </div>

        <div class="header__pricing">
          <!-- <img class="header__pricing" src="../assets/img/simple/header__pricing.png" /> -->
          <!-- <div class="pricing">
                  <div class="pricing__option">
                    2 Week Trial
                  </div>
                  <div class="pricing__option">
                    1 Week Trial
                  </div>
          </div>-->
        </div>

        <!-- <img v-on:click="selectPlan({stripeId: stripePlans.yearly.id, id:'live.studio.ios.YearlyFullService', type: 'yearly', revenue: '99.99'})" src="../assets/img/Button_Try_It_2_Weeks.png"/> -->
        <!-- <img v-on:click="selectPlan({stripeId: stripePlans.monthly.id, id:'live.studio.ios.MonthlyFullService', type: 'monthly', revenue: '14.99'})" src="../assets/img/Button_Try_It_1_Week.png"/> -->

        <div class="user">
          <div class="error_password" v-if="passwordWrongError">
            <!-- <i class="fas fa-exclamation-circle fa-3x"></i> -->
            <i>🤔</i>
            <div>
              <strong>Whoops. Wrong password...</strong>
              <br />Please double-check your password and try again,
              <br />or you can
              <a
                href="https://community.studio.live/account/reset"
              >reset your Studio account</a>
            </div>
          </div>

          <div class="user__input">
            <input
              type="text"
              v-model="tmp.email"
              v-on:keyup="emailExists()"
              placeholder="Email Address"
              autocorrect="off"
              autocapitalize="none"
            />

            <span
              class="input__msg input__msg--warn"
              v-if="!!attemptedSubmit && !validEmail()"
            >Required</span>
            <span class="input__msg input__msg--ok" v-if="validEmail()">
              <i class="fas fa-check"></i>
            </span>
          </div>
          <div class="user__input">
            <input
              type="text"
              @focus="errorFocus = true"
              @blur="errorFocus = false"
              v-model="tmp.password"
              placeholder="Password (6 Characters)"
              autocorrect="off"
              autocapitalize="none"
            />
            <span
              class="input__msg input__msg--info"
              v-if="!!tmp.password && !validPassword() && errorFocus"
            >
              <i
                v-bind:class="{'fas': tmp.password.length >= 1, 'far' : tmp.password.length <= 1}"
                class="fa-circle"
              ></i>
              <i
                v-bind:class="{'fas': tmp.password.length >= 2, 'far' : tmp.password.length <= 2}"
                class="fa-circle"
              ></i>
              <i
                v-bind:class="{'fas': tmp.password.length >= 3, 'far' : tmp.password.length <= 3}"
                class="fa-circle"
              ></i>
              <i
                v-bind:class="{'fas': tmp.password.length >= 4, 'far' : tmp.password.length <= 4}"
                class="fa-circle"
              ></i>
              <i
                v-bind:class="{'fas': tmp.password.length >= 5, 'far' : tmp.password.length <= 5}"
                class="fa-circle"
              ></i>
              <i
                v-bind:class="{'fas': tmp.password.length >= 6, 'far' : tmp.password.length <= 6}"
                class="fa-circle"
              ></i>
              {{tmp.password.length}}/6
            </span>

            <!-- <span class="input__msg input__msg--warn" v-if="passwordWrongError && !errorFocus">Wrong Password</span> -->
            <span
              class="input__msg input__msg--warn"
              v-if="!!attemptedSubmit && !validPassword() && !errorFocus"
            >Required</span>
            <span
              class="input__msg input__msg--ok"
              v-if="validPassword() && !errorFocus && !passwordWrongError"
            >
              <i class="fas fa-check"></i>
            </span>
          </div>

          <button
            class="button button--stripe"
            v-if="!validForm()"
            @click="submitAttempt('stripe')"
          >
            <img src="../assets/img/simple/button__start.png" />
          </button>

          <button
            class="button button--stripe"
            v-if="validForm()"
            @click="register()"
            :disabled="!validForm()"
          >
            <img src="../assets/img/simple/button__start.png" />
          </button>

          <div class="footer__legal">
            You agree to our
            <a
              class="footer__legal--link"
              href="https://studio.live/privacy/"
              target="_blank"
            >privacy policy</a>
            and
            <a
              class="footer__legal--link"
              href="https://studio.live/tos/"
              target="_blank"
            >terms of use</a>
            when&nbsp;subscribing
          </div>
        </div>
      </div>

      <!-- <img src="../assets/img/Web_SelectPlan_blurb.png" /> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
  props: ['api-base', 'subscription', 'loading-indicator'],
  data () {
    return {
      self: this,

      errorFocus: false,
      emailExistsError: false,
      passwordWrongError: false,
      attemptedSubmit: false,
      attemptedSubmitType: null,
      member: {
        data: null,
        whyRunningSet: false,
        subscriptionValid: false
      },

      tmp: {
        birthday: this.createDOB(),

        gender: 'F',
        location: null,
        password: null,
        email: null
      }
    }
  },

  methods: {
    submitAttempt (type) {
      let errors = document.querySelectorAll('.input__msg--warn');

      [].forEach.call(errors, function (error) {
        // do whatever
        error.className += ' input__msg--throb'
      })

      this.attemptedSubmit = true
      this.attemptedSubmitType = type
      console.log(this.attemptedSubmitType)
    },
    validForm () {
      return this.validEmail() && this.validPassword()
    },
    validEmail () {
      // eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var validPattern = re.test(this.tmp.email)
      return validPattern
    },
    validPassword () {
      return this.tmp.password === null ? false : this.tmp.password.length >= 6
    },
    emailExists () {
      if (this.validEmail()) {
        fetch(`${this.apiBase}/users/check/email/${this.tmp.email}`, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        }).then(response => {
          if (response.status === 200) {
            this.emailExistsError = true
            return true
          } else {
            this.emailExistsError = false
            return false
          }
        })
      } else {
        return false
      }
    },

    createEmail () {
      let first = [
        'George',
        'John',
        'Thomas',
        'James',
        'James',
        'John',
        'Andrew',
        'Martin',
        'William',
        'John',
        'James',
        'Zachary',
        'Millard',
        'Franklin',
        'James',
        'Abraham',
        'Andrew',
        'Ulysses',
        'Rutherford',
        'James',
        'Chester',
        'Grover',
        'Benjamin',
        'Grover',
        'William',
        'Theodore',
        'William',
        'Woodrow',
        'Warren',
        'Calvin',
        'Herbert',
        'Franklin',
        'Harry',
        'Dwight',
        'John',
        'Lyndon',
        'Richard',
        'Gerald',
        'Jimmy',
        'Ronald',
        'George',
        'Bill',
        'George',
        'Barack',
        'Donald'
      ]

      let last = [
        'Washington',
        'Adams',
        'Jefferson',
        'Madison',
        'Monroe',
        'Adams',
        'Jackson',
        'VanBuren',
        'Harrison',
        'Tyler',
        'Polk',
        'Taylor',
        'Fillmore',
        'Pierce',
        'Buchanan',
        'Lincoln',
        'Johnson',
        'Grant',
        'Hayes',
        'Garfield',
        'Arthur',
        'Cleveland',
        'Harrison',
        'Cleveland',
        'McKinley',
        'Roosevelt',
        'Taft',
        'Wilson',
        'Harding',
        'Coolidge',
        'Hoover',
        'Roosevelt',
        'Truman',
        'Eisenhower',
        'Kennedy',
        'Johnson',
        'Nixon',
        'Ford',
        'Carter',
        'Reagan',
        'Bush',
        'Clinton',
        'Bush',
        'Obama',
        'Trump'
      ]

      let emailFirst = first[Math.floor(Math.random() * first.length)]
      let emailLast = last[Math.floor(Math.random() * last.length)]

      return `${emailFirst}_${emailLast}@test.com`
    },
    createDOB () {
      let defaultDate = new Date()
      defaultDate.setFullYear(defaultDate.getFullYear() - 29)
      let year = defaultDate.getFullYear()
      let month = defaultDate.getMonth() + 1
      let day = defaultDate.getDate()

      if (day < 10) {
        day = '0' + day
      }
      if (month < 10) {
        month = '0' + month
      }

      return `${year}-${month}-${day}`
    },
    login () {
      fetch(`${this.apiBase}/v2.0/users/email`, {
        method: 'POST',
        body: JSON.stringify({
          email: this.tmp.email,
          password: this.tmp.password
        }),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if (response.status === 200) {
          // this.emailExistsError = true
          // return true

          response.json().then(member => {
            console.log(`
            ##############################################################
            ### A. EMAIL EXISTS; LOGGED IN
            ### ${member.email}
            ##############################################################
            `)
            this.next(member)
          })
        } else {
          console.log(`
          ##############################################################
          ### A. EMAIL EXISTS; LOGIN ATTEMPT - BAD PASSWORD
          ### ${this.tmp.email}
          ##############################################################
          `)

          this.passwordWrongError = true
          this.$emit('loading', false)
        }
      })
    },
    register () {
      this.$emit('loading', true)

      console.log(this.loadingIndicator)
      fetch(`${this.apiBase}/users/check/email/${this.tmp.email}`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }).then(response => {
        console.log(`Reponse Status: ${response.status}`)
        console.log(`Reponse: ${JSON.stringify(response)}`)

        if (response.status === 200) {
          console.log(`
          ##############################################################
          ### A. EMAIL EXISTS; FORWARD TO LOGIN
          ### ${this.tmp.email}
          ##############################################################
          `)

          this.login()
        } else {
          fetch(`${this.apiBase}/v2.0/users/email/new`, {
            method: 'POST',
            body: JSON.stringify(this.tmp),
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            }
          }).then(response => {
            response.json().then(member => {
              this.member = member

              console.log(`
              ##############################################################
              ### A. EMAIL UNIQUE; CREATE MEMBER
              ### ${member.email}
              ##############################################################
              `)

              this.next(this.member)
            })
            // if (response.status === 204) {
            //   this.member = response
            //   this.next(this.member)
            // } else {
            //   console.log('hmmm')
            // }
          })
        }
      })
    },

    next (type) {
      this.$emit('next', type)
    }
  },
  mounted () {
    window.addEventListener('resize', event => {
      window.scrollTo(0, 1)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Register.vue